import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import AdminProtect from "./components/AdminProtect";
import MoreDashboard from "./pages/Dashboard/ECommerce";
import Situation from "./pages/App/situation";
import BattleQuestions from "./pages/App/battleQues";
import CardBg from "./pages/App/cardBg";
import Notification from "./pages/App/notification";
import Analytics from "./pages/App/Analytics";
import Audio from "./pages/App/Audio";

// ─── Inner component so the hook can live inside <BrowserRouter> ─────────────
const AppRoutes = () => {

  return (
    <Routes>
      {/* Dashboard Layout */}
      <Route element={<AppLayout />}>
        <Route index element={<AdminProtect><MoreDashboard /></AdminProtect>} />

        {/* All Pages */}
       
        <Route path="/situation" element={<AdminProtect><Situation /></AdminProtect>} />
        <Route path="/battle-que" element={<AdminProtect><BattleQuestions /></AdminProtect>} />
        <Route path="/cardbg" element={<AdminProtect><CardBg /></AdminProtect>} />
        <Route path="/notification" element={<AdminProtect><Notification /></AdminProtect>} />

        <Route path="/analytics" element={<AdminProtect><Analytics /></AdminProtect>} />
        <Route path="/audio-masking" element={<AdminProtect><Audio /></AdminProtect>} />


        {/* Fallback */}
        <Route path="*" element={<AdminProtect><MoreDashboard /></AdminProtect>} />
      </Route>

      {/* Auth Layout */}
      <Route element={<AuthLayout />}>
        <Route path="login" element={<SignIn />} />
      </Route>
    </Routes>
  );
};

// ─── Root App ─────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter basename="/">
        <AppRoutes />
        <ToastContainer position="top-right" className="!z-[99999]" />
    </BrowserRouter>
  );
}